import { SubjectDesign } from '../shared/SubjectContent.types';

// Figma 최종 분리파일 및 2026-10-23 검수 반영. 좌표는 GNB 125px을 제외한 본문 기준.
export const finalDesign: SubjectDesign = {
    height: 11742,
    backgrounds: [
        {
            top: 9067,
            height: 2675,
            color: '#f3f3f3',
        },
        {
            top: 6487,
            height: 2580,
            color: '#f3f3f3',
        },
        {
            top: 5445,
            height: 602,
            file: 'backdrop-5570.png',
        },
        {
            top: 2385,
            height: 3061,
            file: 'backdrop-2510.png',
        },
        {
            top: 1996,
            height: 390,
            color: '#ff7b38',
        },
        {
            top: 1127,
            height: 869,
            color: '#fff5ef',
        },
        {
            top: 809,
            height: 318,
            color: '#ff7b38',
        },
        {
            top: 0,
            height: 810,
            file: 'backdrop-125.png',
        },
    ],
    artworks: [
        {
            top: 0,
            left: 0,
            width: 1260,
            height: 810,
            file: 'section-0.webp',
            alt: '한글·국어 학습 어린이와 윙크 학습기',
        },
        {
            top: 1127,
            left: 0,
            width: 1260,
            height: 869,
            file: 'section-1.webp',
            alt: '한글·국어 학습 영역 안내',
        },
        {
            top: 1996,
            left: 0,
            width: 1260,
            height: 390,
            file: 'section-2.webp',
            alt: '한글·국어 학습 4단계 흐름',
        },
        {
            top: 2386,
            left: 0,
            width: 1260,
            height: 3060,
            file: 'section-3.webp',
            alt: '한글·국어 학습 콘텐츠 예시',
        },
        {
            top: 5447,
            left: 0,
            width: 1260,
            height: 600,
            file: 'section-4.webp',
            alt: '한글·국어 학습 효과 안내',
        },
        {
            top: 6047,
            left: -650,
            width: 2560,
            height: 440,
            file: 'section-5.webp',
            alt: '한글·국어 단계별 커리큘럼',
        },
        {
            top: 6487,
            left: 0,
            width: 1260,
            height: 2580,
            file: 'section-6.webp',
            alt: '안녕 한글부터 한글 2단계 학습 예시',
        },
        {
            top: 9067,
            left: 0,
            width: 1260,
            height: 2675,
            file: 'section-7.webp',
            alt: '한글 3단계부터 국어 5단계 학습 예시',
        },
    ],
    sections: [
        {
            key: 'contents_0(메인)',
            top: 0,
            height: 810,
        },
        {
            key: 'contents_1',
            top: 809,
            height: 1187,
        },
        {
            key: 'contents_2',
            top: 1996,
            height: 390,
            groups: [
                {
                    kind: 'list',
                    label: '한글·국어 학습 4단계',
                    items: [
                        ['2019:681', '2019:675'],
                        ['2019:682', '2019:676'],
                        ['2019:683', '2019:677'],
                        ['2019:684', '2019:678'],
                    ],
                },
            ],
        },
        {
            key: 'contents_3',
            top: 2385,
            height: 3060,
        },
        {
            key: 'contents_4',
            top: 5445,
            height: 602,
        },
        {
            key: 'contents_5',
            top: 6047,
            height: 440,
            groups: [
                {
                    kind: 'list',
                    label: '한글·국어 수준별 6개 과정',
                    items: [
                        ['2019:606', '2019:603', '2019:602'],
                        ['2019:607', '2019:601', '2019:600'],
                        ['2019:608', '2019:599', '2019:598'],
                        ['2019:609', '2019:597', '2019:596'],
                        ['2019:610', '2019:595', '2019:594'],
                        ['2019:611', '2019:593', '2019:592'],
                    ],
                },
            ],
        },
        {
            key: 'contents_6',
            top: 6487,
            height: 2580,
            groups: [
                {
                    kind: 'course',
                    heading: '2019:583',
                    keys: ['2019:583', '2019:584', '2019:586', '2019:587', '2019:588'],
                },
                {
                    kind: 'course',
                    heading: '2019:579',
                    keys: ['2019:579', '2019:580', '2019:574', '2019:575', '2019:577', '2019:576'],
                },
                {
                    kind: 'course',
                    heading: '2019:572',
                    keys: ['2019:572', '2019:573', '2019:570', '2019:566', '2019:567', '2019:569', '2019:568'],
                },
            ],
        },
        {
            key: 'contents_7',
            top: 9067,
            height: 2675,
            groups: [
                {
                    kind: 'course',
                    heading: '2019:540',
                    keys: ['2019:540', '2019:541', '2019:534', '2019:535', '2019:536', '2019:537'],
                },
                {
                    kind: 'course',
                    heading: '2019:555',
                    keys: ['2019:555', '2019:556', '2019:557', '2019:550', '2019:551', '2019:552'],
                },
                {
                    kind: 'course',
                    heading: '2019:548',
                    keys: ['2019:548', '2019:549', '2019:542', '2019:543', '2019:544', '2019:545'],
                },
            ],
        },
    ],
    texts: [
        {
            key: '2019:715',
            tag: 'p',
            left: 57.5,
            top: 272,
            width: 83,
            height: 28,
            lineHeight: 28,
            letterSpacing: '0.1em',
            runs: [
                {
                    text: '한글∙국어',
                    left: 0.078,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 20,
            weight: 700,
            color: 'white',
        },
        {
            key: '2019:717',
            tag: 'h1',
            left: 47,
            top: 320.5,
            width: 515,
            height: 225,
            lineHeight: 75,
            runs: [
                {
                    text: '글을 읽고 쓰는 것부터',
                    left: 0,
                    top: 0,
                },
                {
                    text: '이해하는 힘까지 ',
                    left: 0,
                    top: 75,
                },
                {
                    text: '키웁니다 ',
                    left: 0,
                    top: 150,
                },
            ],
            font: 'Paperlogy',
            size: 60,
            weight: 800,
            color: 'white',
        },
        {
            key: '2019:709',
            tag: 'p',
            left: 402,
            top: 880,
            width: 459,
            height: 39,
            lineHeight: 39,
            runs: [
                {
                    text: '글자만 반복한다고 뜻까지 알게 될까요?',
                    left: 0.06,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 30,
            weight: 600,
            color: 'white',
        },
        {
            key: '2019:708',
            tag: 'h2',
            left: 300,
            top: 938,
            width: 675,
            height: 130,
            lineHeight: 65,
            runs: [
                {
                    text: '이야기로 이해하고, 직접 읽고 쓰며',
                    left: 0.293,
                    top: 0,
                },
                {
                    text: '익히는 ',
                    left: 119.6,
                    top: 65,
                },
                {
                    text: '윙크 한글∙국어',
                    color: '#FFF345',
                    left: 262.57,
                    top: 65,
                },
            ],
            font: 'Paperlogy',
            size: 50,
            weight: 800,
            color: 'white',
        },
        {
            key: '2019:690',
            tag: 'h2',
            left: 366,
            top: 1204,
            width: 535,
            height: 65,
            lineHeight: 65,
            runs: [
                {
                    text: '윙크 수준별 ',
                    left: 0,
                    top: 0,
                },
                {
                    text: '한글∙국어',
                    color: '#FF7B38',
                    left: 241.94,
                    top: 0,
                },
                {
                    text: ' 구성',
                    left: 435.79,
                    top: 0,
                },
            ],
            font: 'Paperlogy',
            size: 50,
            weight: 800,
            color: '#1D1D1D',
        },
        {
            key: '2019:697',
            tag: 'p',
            left: 239.7832,
            top: 1493.9443,
            width: 182,
            height: 39,
            lineHeight: 39,
            runs: [
                {
                    text: '단계별 윙크 한글',
                    left: 0.2028,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 28,
            weight: 800,
            color: '#1D1D1D',
        },
        {
            key: '2019:700',
            tag: 'p',
            left: 536.8296,
            top: 1493.9443,
            width: 182,
            height: 36,
            lineHeight: 36,
            runs: [
                {
                    text: '영역별 윙크 국어',
                    left: 0.2004,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 28,
            weight: 800,
            color: '#1D1D1D',
        },
        {
            key: '2019:703',
            tag: 'p',
            left: 845.9219,
            top: 1493.9443,
            width: 158,
            height: 36,
            lineHeight: 36,
            runs: [
                {
                    text: '초등 준비 학습',
                    left: 0.3081,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 28,
            weight: 800,
            color: '#1D1D1D',
        },
        {
            key: '2019:698',
            tag: 'p',
            left: 279.8868,
            top: 1532.0287,
            width: 100,
            height: 36,
            lineHeight: 36,
            runs: [
                {
                    text: '1~3단계',
                    left: 0.4082,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 28,
            weight: 800,
            color: '#1D1D1D',
        },
        {
            key: '2019:701',
            tag: 'p',
            left: 574.9421,
            top: 1532.0287,
            width: 105,
            height: 36,
            lineHeight: 36,
            runs: [
                {
                    text: '4~5단계',
                    left: 0.3379,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 28,
            weight: 800,
            color: '#1D1D1D',
        },
        {
            key: '2019:704',
            tag: 'p',
            left: 872.5401,
            top: 1532.0287,
            width: 103,
            height: 36,
            lineHeight: 36,
            runs: [
                {
                    text: '개념 국어',
                    left: 0.0499,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 28,
            weight: 800,
            color: '#1D1D1D',
        },
        {
            key: '2019:692',
            tag: 'p',
            left: 162,
            top: 1664,
            width: 922,
            height: 28,
            lineHeight: 28,
            runs: [
                {
                    text: '윙크 한글은 적절한 시기에 한글을 깨치며 필요한 지식과 경험을 쌓고 글 읽기를 좋아하는 아이로 성장하게 해줍니다.',
                    left: 30,
                    top: 0,
                },
            ],
            bullet: true,
            font: 'Pretendard',
            size: 20,
            weight: 500,
            color: '#1D1D1D',
        },
        {
            key: '2019:693',
            tag: 'p',
            left: 162,
            top: 1728,
            width: 819,
            height: 28,
            lineHeight: 28,
            runs: [
                {
                    text: '윙크 국어는 “어휘력, 문장력, 독해력, 문법지식"등 국어의 기초 경쟁력을 키워줍니다.',
                    left: 30,
                    top: 0,
                },
            ],
            bullet: true,
            font: 'Pretendard',
            size: 20,
            weight: 500,
            color: '#1D1D1D',
        },
        {
            key: '2019:694',
            tag: 'p',
            left: 162,
            top: 1792,
            width: 892,
            height: 56,
            lineHeight: 28,
            runs: [
                {
                    text: '입학 전, 초등 준비 학습 프로그램을 통해 학교 진도와 동일한 교과학습을 미리 공부할 수 있어',
                    left: 30,
                    top: 0,
                },
                {
                    text: '입학 후, 학교 학습에 쉽게 적응할 수 있습니다.',
                    left: 30,
                    top: 28,
                },
            ],
            bullet: true,
            font: 'Pretendard',
            size: 20,
            weight: 500,
            color: '#1D1D1D',
        },
        {
            key: '2019:679',
            tag: 'h2',
            left: 309,
            top: 2051,
            width: 634,
            height: 65,
            lineHeight: 65,
            runs: [
                {
                    text: '윙크 수준별 한글∙국어 학습 흐름',
                    left: 0.13,
                    top: 0,
                },
            ],
            font: 'Paperlogy',
            size: 50,
            weight: 800,
            color: 'white',
        },
        {
            key: '2019:681',
            tag: 'p',
            left: 173,
            top: 2148.999,
            width: 50,
            height: 29,
            lineHeight: 29,
            letterSpacing: '-0.03em',
            runs: [
                {
                    text: 'STEP 1',
                    left: 0,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 16,
            weight: 800,
            color: 'white',
        },
        {
            key: '2019:682',
            tag: 'p',
            left: 459,
            top: 2148.999,
            width: 52,
            height: 29,
            lineHeight: 29,
            letterSpacing: '-0.03em',
            runs: [
                {
                    text: 'STEP 2',
                    left: 0,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 16,
            weight: 800,
            color: 'white',
        },
        {
            key: '2019:683',
            tag: 'p',
            left: 747,
            top: 2148.999,
            width: 52,
            height: 29,
            lineHeight: 29,
            letterSpacing: '-0.03em',
            runs: [
                {
                    text: 'STEP 3',
                    left: 0,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 16,
            weight: 800,
            color: 'white',
        },
        {
            key: '2019:684',
            tag: 'p',
            left: 1035,
            top: 2148.999,
            width: 53,
            height: 29,
            lineHeight: 29,
            letterSpacing: '-0.03em',
            runs: [
                {
                    text: 'STEP 4',
                    left: 0,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 16,
            weight: 800,
            color: 'white',
        },
        {
            key: '2019:675',
            tag: 'p',
            left: 124.0254,
            top: 2209.8691,
            width: 139.0927,
            height: 85.6822,
            lineHeight: 39,
            runs: [
                {
                    text: '즐겁게',
                    left: 30.6526,
                    top: 0,
                },
                {
                    text: '배워요',
                    left: 30.6526,
                    top: 39,
                },
            ],
            font: 'Pretendard',
            size: 30,
            weight: 800,
            color: '#1D1D1D',
        },
        {
            key: '2019:676',
            tag: 'p',
            left: 412.3105,
            top: 2209.8691,
            width: 139.0927,
            height: 85.6822,
            lineHeight: 39,
            runs: [
                {
                    text: '스스로',
                    left: 30.6595,
                    top: 0,
                },
                {
                    text: '익혀요',
                    left: 30.6595,
                    top: 39,
                },
            ],
            font: 'Pretendard',
            size: 30,
            weight: 800,
            color: '#1D1D1D',
        },
        {
            key: '2019:677',
            tag: 'p',
            left: 704.5957,
            top: 2209.8691,
            width: 139.0927,
            height: 85.6822,
            lineHeight: 39,
            runs: [
                {
                    text: '학습지를',
                    left: 17.6843,
                    top: 0,
                },
                {
                    text: '풀어요',
                    left: 30.6543,
                    top: 39,
                },
            ],
            font: 'Pretendard',
            size: 30,
            weight: 800,
            color: '#1D1D1D',
        },
        {
            key: '2019:678',
            tag: 'p',
            left: 991.8809,
            top: 2210.2617,
            width: 139.0927,
            height: 85.6822,
            lineHeight: 39,
            runs: [
                {
                    text: '함께',
                    left: 43.6091,
                    top: 0,
                },
                {
                    text: '확인해요',
                    left: 17.6891,
                    top: 39,
                },
            ],
            font: 'Pretendard',
            size: 30,
            weight: 800,
            color: '#1D1D1D',
        },
        {
            key: '2019:639',
            tag: 'h2',
            left: 327,
            top: 2543,
            width: 614,
            height: 52,
            lineHeight: 52,
            runs: [
                {
                    text: '즐겁게 ',
                    left: 197.02,
                    top: 0,
                },
                {
                    text: '배워요',
                    color: '#1D1D1D',
                    left: 311.39,
                    top: 0,
                },
            ],
            font: 'Paperlogy',
            size: 40,
            weight: 800,
            color: '#FF4A00',
        },
        {
            key: '2019:640',
            tag: 'p',
            left: 327,
            top: 2597,
            width: 614,
            height: 34,
            lineHeight: 34,
            runs: [
                {
                    text: '재미있고 자연스럽게 글자와 개념을 깨치니까 언어 활용 능력이 쭉!',
                    left: 0.25,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 24,
            weight: 500,
            color: '#1D1D1D',
        },
        {
            key: '2019:627',
            tag: 'h3',
            left: 294,
            top: 2923,
            width: 236,
            height: 32,
            lineHeight: 32,
            runs: [
                {
                    text: '재미있는 한글',
                    left: 53.008,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 24,
            weight: 700,
            color: '#1D1D1D',
        },
        {
            key: '2019:630',
            tag: 'h3',
            left: 706,
            top: 2923,
            width: 283,
            height: 32,
            lineHeight: 32,
            runs: [
                {
                    text: '노래로 한글',
                    left: 86.88,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 24,
            weight: 700,
            color: '#1D1D1D',
        },
        {
            key: '2019:628',
            tag: 'p',
            left: 294,
            top: 2960,
            width: 236,
            height: 54,
            lineHeight: 27,
            runs: [
                {
                    text: '다양한 간접 경험을 통해 상상력을',
                    left: 0.314,
                    top: 0,
                },
                {
                    text: '풍부하게 키워줍니다.',
                    left: 43.425,
                    top: 27,
                },
            ],
            font: 'Pretendard',
            size: 18,
            weight: 500,
            color: '#1D1D1D',
        },
        {
            key: '2019:631',
            tag: 'p',
            left: 706,
            top: 2960,
            width: 283,
            height: 54,
            lineHeight: 27,
            runs: [
                {
                    text: '읽었던 이야기의 내용을 동요와 율동으로',
                    left: 0.48,
                    top: 0,
                },
                {
                    text: '재미있게 만납니다.',
                    left: 74.7,
                    top: 27,
                },
            ],
            font: 'Pretendard',
            size: 18,
            weight: 500,
            color: '#1D1D1D',
        },
        {
            key: '2019:633',
            tag: 'h3',
            left: 271,
            top: 3278,
            width: 281,
            height: 32,
            lineHeight: 32,
            runs: [
                {
                    text: '이야기속 한글',
                    left: 75.508,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 24,
            weight: 700,
            color: '#1D1D1D',
        },
        {
            key: '2019:636',
            tag: 'h3',
            left: 681,
            top: 3278,
            width: 334,
            height: 32,
            lineHeight: 32,
            runs: [
                {
                    text: '생활 속 한글',
                    left: 109.61,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 24,
            weight: 700,
            color: '#1D1D1D',
        },
        {
            key: '2019:634',
            tag: 'p',
            left: 271,
            top: 3315,
            width: 281,
            height: 54,
            lineHeight: 27,
            runs: [
                {
                    text: '동화 내용에 몰입할 수 있는 장치를 마련,',
                    left: 0.455,
                    top: 0,
                },
                {
                    text: '읽는 재미를 느끼게 됩니다.',
                    left: 45.974,
                    top: 27,
                },
            ],
            font: 'Pretendard',
            size: 18,
            weight: 500,
            color: '#1D1D1D',
        },
        {
            key: '2019:637',
            tag: 'p',
            left: 681,
            top: 3315,
            width: 334,
            height: 54,
            lineHeight: 27,
            runs: [
                {
                    text: '학습한 내용이 생활 속에서 어떤 모습으로 ',
                    left: 21.58,
                    top: 0,
                },
                {
                    text: '존재하는지 살펴보며 살아있는 지식을 배웁니다.',
                    left: 0.27,
                    top: 27,
                },
            ],
            font: 'Pretendard',
            size: 18,
            weight: 500,
            color: '#1D1D1D',
        },
        {
            key: '2019:649',
            tag: 'h2',
            left: 207,
            top: 3543,
            width: 854,
            height: 52,
            lineHeight: 52,
            runs: [
                {
                    text: '스스로 ',
                    left: 317.02,
                    top: 0,
                },
                {
                    text: '익혀요',
                    color: '#1D1D1D',
                    left: 431.39,
                    top: 0,
                },
            ],
            font: 'Paperlogy',
            size: 40,
            weight: 800,
            color: '#FF4A00',
        },
        {
            key: '2019:650',
            tag: 'p',
            left: 207,
            top: 3597,
            width: 854,
            height: 34,
            lineHeight: 34,
            runs: [
                {
                    text: '학습게임과 확인 학습을 통해 실력을 다지고 틀린문제는 반복학습을 통해 완벽히 이해합니다.',
                    left: 0.438,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 24,
            weight: 500,
            color: '#1D1D1D',
        },
        {
            key: '2019:643',
            tag: 'h3',
            left: 278,
            top: 3933,
            width: 267,
            height: 32,
            lineHeight: 32,
            runs: [
                {
                    text: '놀이로 학습',
                    left: 78.88,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 24,
            weight: 700,
            color: '#1D1D1D',
        },
        {
            key: '2019:646',
            tag: 'h3',
            left: 669,
            top: 3933,
            width: 358,
            height: 32,
            lineHeight: 32,
            runs: [
                {
                    text: '딩동댕 정리하기',
                    left: 103.64,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 24,
            weight: 700,
            color: '#1D1D1D',
        },
        {
            key: '2019:644',
            tag: 'p',
            left: 278,
            top: 3970,
            width: 267,
            height: 27,
            lineHeight: 27,
            runs: [
                {
                    text: '학습한 내용을 통해 자연스럽게 익혀요',
                    left: 0.258,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 18,
            weight: 500,
            color: '#1D1D1D',
        },
        {
            key: '2019:647',
            tag: 'p',
            left: 669,
            top: 3970,
            width: 358,
            height: 27,
            lineHeight: 27,
            runs: [
                {
                    text: '퀴즈 또는 문제를 풀어보며 하루의 학습을 점검해요.',
                    left: 0.1,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 18,
            weight: 500,
            color: '#1D1D1D',
        },
        {
            key: '2019:659',
            tag: 'h2',
            left: 204,
            top: 4161,
            width: 859,
            height: 52,
            lineHeight: 52,
            runs: [
                {
                    text: '학습지를 ',
                    left: 301.92,
                    top: 0,
                },
                {
                    text: '풀어요',
                    color: '#1D1D1D',
                    left: 451.49,
                    top: 0,
                },
            ],
            font: 'Paperlogy',
            size: 40,
            weight: 800,
            color: '#FF4A00',
        },
        {
            key: '2019:660',
            tag: 'p',
            left: 204,
            top: 4213,
            width: 859,
            height: 34,
            lineHeight: 34,
            runs: [
                {
                    text: '손으로 직접 쓰면서 풀어, 내 것이 됩니다.',
                    left: 239.74,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 24,
            weight: 500,
            color: '#1D1D1D',
        },
        {
            key: '2019:653',
            tag: 'h3',
            left: 312,
            top: 4552,
            width: 200,
            height: 32,
            lineHeight: 32,
            runs: [
                {
                    text: '학습지 풀기',
                    left: 45.38,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 24,
            weight: 700,
            color: '#1D1D1D',
        },
        {
            key: '2019:656',
            tag: 'h3',
            left: 704,
            top: 4552,
            width: 287,
            height: 32,
            lineHeight: 32,
            runs: [
                {
                    text: '모르는 문제는 스스로 해결하기',
                    left: 0.38,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 24,
            weight: 700,
            color: '#1D1D1D',
        },
        {
            key: '2019:654',
            tag: 'p',
            left: 312,
            top: 4589,
            width: 200,
            height: 54,
            lineHeight: 27,
            runs: [
                {
                    text: '매일 제공되는 학습지를 풀며',
                    left: 0.068,
                    top: 0,
                },
                {
                    text: '완전히 내것으로 만들어요.',
                    left: 7.671,
                    top: 27,
                },
            ],
            font: 'Pretendard',
            size: 18,
            weight: 500,
            color: '#1D1D1D',
        },
        {
            key: '2019:657',
            tag: 'p',
            left: 714,
            top: 4589,
            width: 267,
            height: 54,
            lineHeight: 27,
            runs: [
                {
                    text: '학습지를 풀다가 모르는 문제가 나오면',
                    left: 0.26,
                    top: 0,
                },
                {
                    text: '선생님 설명을 듣고 해결해요.',
                    left: 31.2,
                    top: 27,
                },
            ],
            font: 'Pretendard',
            size: 18,
            weight: 500,
            color: '#1D1D1D',
        },
        {
            key: '2019:663',
            tag: 'h2',
            left: 204,
            top: 4804,
            width: 859,
            height: 52,
            lineHeight: 52,
            runs: [
                {
                    text: '선생님 또는 부모님과 ',
                    left: 147.96,
                    top: 0,
                },
                {
                    text: '함께 확인해요',
                    color: '#1D1D1D',
                    left: 491.08,
                    top: 0,
                },
            ],
            font: 'Paperlogy',
            size: 40,
            weight: 800,
            color: '#FF4A00',
        },
        {
            key: '2019:664',
            tag: 'p',
            left: 204,
            top: 4858,
            width: 859,
            height: 34,
            lineHeight: 34,
            runs: [
                {
                    text: '배운 내용을 선생님 또는 학부모님과 함께 확인하니까 더 오랫동안 기억할 수 있습니다.',
                    left: 31.121,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 24,
            weight: 500,
            color: '#1D1D1D',
        },
        {
            key: '2019:666',
            tag: 'h3',
            left: 278,
            top: 5206,
            width: 267,
            height: 32,
            lineHeight: 32,
            runs: [
                {
                    text: '선생님과 함께 확인',
                    left: 45,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 24,
            weight: 700,
            color: '#1D1D1D',
        },
        {
            key: '2019:669',
            tag: 'h3',
            left: 670,
            top: 5206,
            width: 356,
            height: 32,
            lineHeight: 32,
            runs: [
                {
                    text: '부모님과 함께 확인',
                    left: 89.5,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 24,
            weight: 700,
            color: '#1D1D1D',
        },
        {
            key: '2019:667',
            tag: 'p',
            left: 278,
            top: 5243,
            width: 267,
            height: 54,
            lineHeight: 27,
            runs: [
                {
                    text: '선생님의 실시간 코칭으로 배운 내용을',
                    left: 0.258,
                    top: 0,
                },
                {
                    text: '한 번 더 이야기하며 확인해요.',
                    left: 28.998,
                    top: 27,
                },
            ],
            font: 'Pretendard',
            size: 18,
            weight: 500,
            color: '#1D1D1D',
        },
        {
            key: '2019:670',
            tag: 'p',
            left: 670,
            top: 5243,
            width: 356,
            height: 54,
            lineHeight: 27,
            runs: [
                {
                    text: '전체 학습 현황과 틀린 문제를 쉽게  확인할 수 있고,',
                    left: 0.25,
                    top: 0,
                },
                {
                    text: '틀린 문제는 클릭 한 번으로 재학습할 수 있어요.',
                    left: 12.46,
                    top: 27,
                },
            ],
            font: 'Pretendard',
            size: 18,
            weight: 500,
            color: '#1D1D1D',
        },
        {
            key: '2019:620',
            tag: 'h2',
            left: 250,
            top: 5515,
            width: 763,
            height: 52,
            lineHeight: 52,
            runs: [
                {
                    text: '윙크 수준별 한글∙국어 단계별 ',
                    left: 0,
                    top: 0,
                },
                {
                    text: '커리큘럼',
                    color: '#FF4A00',
                    left: 471.8,
                    top: 0,
                },
                {
                    text: ' 상세보기 ',
                    left: 612.58,
                    top: 0,
                },
            ],
            font: 'Paperlogy',
            size: 40,
            weight: 800,
            color: '#1D1D1D',
        },
        {
            key: '2019:617',
            tag: 'p',
            left: 178,
            top: 5670,
            width: 907,
            height: 62,
            lineHeight: 28,
            runs: [
                {
                    text: '초등 1~2학년 한글의 기초부터 글쓰기/설명문 등 단기간에 학습 편차가 큰 내용들을 배우기 때문에',
                    left: 75.8342,
                    top: 0,
                },
                {
                    text: '제대로 실력을 키우기 어렵습니다.',
                    left: 322.5417,
                    top: 28,
                },
            ],
            font: 'Pretendard',
            size: 20,
            weight: 500,
            color: '#565656',
        },
        {
            key: '2019:618',
            tag: 'p',
            left: 178,
            top: 5759,
            width: 907,
            height: 62,
            lineHeight: 28,
            runs: [
                {
                    text: '갑자기 어려워지는 3학년 국어를 탄탄하게 대비하기 위해서는 교과서 지문으로 한계가 있으므로,',
                    left: 83.1092,
                    top: 0,
                },
                {
                    text: '윙크와 같은 수준별 학습을 통해 다양한 글감을 충분히 익히는 것이 필수입니다.',
                    left: 149.8867,
                    top: 28,
                },
            ],
            font: 'Pretendard',
            size: 20,
            weight: 500,
            color: '#565656',
        },
        {
            key: '2019:619',
            tag: 'p',
            left: 178,
            top: 5848,
            width: 907,
            height: 62,
            lineHeight: 28,
            runs: [
                {
                    text: '윙크 한글',
                    left: 111.5667,
                    top: 0,
                },
                {
                    text: '∙',
                    left: 185.18,
                    top: 0,
                },
                {
                    text: '국어 5단계까지 학습할 경우, 무료 초등 3~4학년 수준까지 커버가 가능하므로,',
                    left: 190.57,
                    top: 0,
                },
                {
                    text: '기초 학습은 물론 심화 학습까지 충분히 대비할 수 있습니다.',
                    left: 225.2667,
                    top: 28,
                },
            ],
            font: 'Pretendard',
            size: 20,
            weight: 800,
            color: '#FF4A00',
        },
        {
            key: '2019:604',
            tag: 'h2',
            left: 322,
            top: 6112,
            width: 623,
            height: 65,
            lineHeight: 65,
            runs: [
                {
                    text: '윙크 수준별 한글∙국어 커리큘럼',
                    left: 0.123,
                    top: 0,
                },
            ],
            font: 'Paperlogy',
            size: 50,
            weight: 800,
            color: '#1D1D1D',
        },
        {
            key: '2019:611',
            tag: 'p',
            left: 1274,
            top: 6208.999,
            width: 67,
            height: 29,
            lineHeight: 29,
            letterSpacing: '-0.03em',
            runs: [
                {
                    text: '국어 5단계',
                    left: 0.15,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 16,
            weight: 500,
            color: 'white',
        },
        {
            key: '2019:606',
            tag: 'p',
            left: -89,
            top: 6209.999,
            width: 87,
            height: 29,
            lineHeight: 29,
            letterSpacing: '-0.03em',
            runs: [
                {
                    text: '안녕 한글 단계',
                    left: 0,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 16,
            weight: 500,
            color: 'white',
        },
        {
            key: '2019:607',
            tag: 'p',
            left: 193,
            top: 6209.999,
            width: 65,
            height: 29,
            lineHeight: 29,
            letterSpacing: '-0.03em',
            runs: [
                {
                    text: '한글 1단계',
                    left: 0.427,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 16,
            weight: 500,
            color: 'white',
        },
        {
            key: '2019:608',
            tag: 'p',
            left: 462,
            top: 6209.999,
            width: 67,
            height: 29,
            lineHeight: 29,
            letterSpacing: '-0.03em',
            runs: [
                {
                    text: '한글 2단계',
                    left: 0.31,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 16,
            weight: 500,
            color: 'white',
        },
        {
            key: '2019:609',
            tag: 'p',
            left: 734,
            top: 6209.999,
            width: 67,
            height: 29,
            lineHeight: 29,
            letterSpacing: '-0.03em',
            runs: [
                {
                    text: '한글 3단계',
                    left: 0.08,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 16,
            weight: 500,
            color: 'white',
        },
        {
            key: '2019:610',
            tag: 'p',
            left: 1002,
            top: 6210,
            width: 68,
            height: 29,
            lineHeight: 29,
            letterSpacing: '-0.03em',
            runs: [
                {
                    text: '국어 4단계',
                    left: 0.41,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 16,
            weight: 500,
            color: 'white',
        },
        {
            key: '2019:603',
            tag: 'h3',
            left: -138,
            top: 6271,
            width: 184,
            height: 68,
            lineHeight: 34,
            runs: [
                {
                    text: '언어 자극을 통한',
                    left: 13.871,
                    top: 0,
                },
                {
                    text: '어휘력, 표현력 향상 ',
                    left: 0.43,
                    top: 34,
                },
            ],
            font: 'Pretendard',
            size: 24,
            weight: 700,
            color: '#1D1D1D',
        },
        {
            key: '2019:601',
            tag: 'h3',
            left: 139,
            top: 6271,
            width: 172,
            height: 68,
            lineHeight: 34,
            runs: [
                {
                    text: '그림글자를 활용한',
                    left: 0.266,
                    top: 0,
                },
                {
                    text: '통문자 학습',
                    left: 31.379,
                    top: 34,
                },
            ],
            font: 'Pretendard',
            size: 24,
            weight: 700,
            color: '#1D1D1D',
        },
        {
            key: '2019:599',
            tag: 'h3',
            left: 424,
            top: 6271,
            width: 142,
            height: 68,
            lineHeight: 34,
            runs: [
                {
                    text: '낱글자와',
                    left: 29.52,
                    top: 0,
                },
                {
                    text: '자음, 모음 학습',
                    left: 0.17,
                    top: 34,
                },
            ],
            font: 'Pretendard',
            size: 24,
            weight: 700,
            color: '#1D1D1D',
        },
        {
            key: '2019:597',
            tag: 'h3',
            left: 655,
            top: 6271,
            width: 225,
            height: 68,
            lineHeight: 34,
            runs: [
                {
                    text: '받침있는 자음, 모음',
                    left: 20.93,
                    top: 0,
                },
                {
                    text: '조합과 문장 읽기의 기초',
                    left: 0.49,
                    top: 34,
                },
            ],
            font: 'Pretendard',
            size: 24,
            weight: 700,
            color: '#1D1D1D',
        },
        {
            key: '2019:595',
            tag: 'h3',
            left: 934,
            top: 6271,
            width: 204,
            height: 68,
            lineHeight: 34,
            runs: [
                {
                    text: '문장 쓰기와',
                    left: 47.38,
                    top: 0,
                },
                {
                    text: '기초문법 짧은 글 읽기',
                    left: 0.36,
                    top: 34,
                },
            ],
            font: 'Pretendard',
            size: 24,
            weight: 700,
            color: '#1D1D1D',
        },
        {
            key: '2019:593',
            tag: 'h3',
            left: 1208,
            top: 6271,
            width: 198,
            height: 68,
            lineHeight: 34,
            runs: [
                {
                    text: '심화 문법과 국어지식',
                    left: 0.13,
                    top: 0,
                },
                {
                    text: '긴 글 독해력 학습',
                    left: 18.11,
                    top: 34,
                },
            ],
            font: 'Pretendard',
            size: 24,
            weight: 700,
            color: '#1D1D1D',
        },
        {
            key: '2019:602',
            tag: 'p',
            left: -119,
            top: 6346,
            width: 145,
            height: 22,
            lineHeight: 22,
            runs: [
                {
                    text: '권장 연령: 30~38개월',
                    left: 0.117,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 16,
            weight: 500,
            color: '#1D1D1D',
        },
        {
            key: '2019:600',
            tag: 'p',
            left: 154,
            top: 6346,
            width: 143,
            height: 22,
            lineHeight: 22,
            runs: [
                {
                    text: '권장 연령: 4~5세 적합',
                    left: 0.117,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 16,
            weight: 500,
            color: '#1D1D1D',
        },
        {
            key: '2019:598',
            tag: 'p',
            left: 424,
            top: 6346,
            width: 142,
            height: 22,
            lineHeight: 22,
            runs: [
                {
                    text: '권장 연령: 6~7세 적합',
                    left: 0.28,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 16,
            weight: 500,
            color: '#1D1D1D',
        },
        {
            key: '2019:596',
            tag: 'p',
            left: 697,
            top: 6346,
            width: 142,
            height: 22,
            lineHeight: 22,
            runs: [
                {
                    text: '권장 연령: 7~8세 적합',
                    left: 0.12,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 16,
            weight: 500,
            color: '#1D1D1D',
        },
        {
            key: '2019:594',
            tag: 'p',
            left: 965,
            top: 6346,
            width: 143,
            height: 22,
            lineHeight: 22,
            runs: [
                {
                    text: '권장 연령: 8~9세 적합',
                    left: 0.12,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 16,
            weight: 500,
            color: '#1D1D1D',
        },
        {
            key: '2019:592',
            tag: 'p',
            left: 1232,
            top: 6346,
            width: 150,
            height: 22,
            lineHeight: 22,
            runs: [
                {
                    text: '권장 연령: 9~10세 적합',
                    left: 0.04,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 16,
            weight: 500,
            color: '#1D1D1D',
        },
        {
            key: '2019:583',
            tag: 'h3',
            left: 573,
            top: 6625,
            width: 114,
            height: 28,
            lineHeight: 28,
            runs: [
                {
                    text: '안녕 한글 단계',
                    left: 0.26,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 20,
            weight: 500,
            color: 'white',
        },
        {
            key: '2019:584',
            tag: 'p',
            left: 429,
            top: 6655,
            width: 402,
            height: 36,
            lineHeight: 36,
            runs: [
                {
                    text: '언어 자극을 통한 어휘력, 표현력 향상',
                    left: 0.28,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 28,
            weight: 800,
            color: 'white',
        },
        {
            key: '2019:586',
            tag: 'p',
            left: 176,
            top: 7029,
            width: 876,
            height: 84,
            lineHeight: 28,
            runs: [
                {
                    text: '윙크 안녕 한글 단계는 언어 발달이 폭발적으로 이루어지는 시기에 필요한 다양한 언어 자극을 제공합니다.',
                    left: 30,
                    top: 0,
                },
                {
                    text: '      쉽게 이해할 수 있도록 구성된',
                    left: 0,
                    top: 28,
                },
                {
                    text: '재미있는 상황 속에서 주요 낱말과 관련된 표현들을 자연스럽게 노출하여 어휘를',
                    color: '#FF4A00',
                    left: 261.13,
                    top: 28,
                },
                {
                    text: '      확장하고 표현력을 향상시킵니다.',
                    color: '#FF4A00',
                    left: 0,
                    top: 56,
                },
            ],
            bullet: true,
            font: 'Pretendard',
            size: 20,
            weight: 500,
            color: '#1D1D1D',
        },
        {
            key: '2019:587',
            tag: 'p',
            left: 176,
            top: 7138,
            width: 886,
            height: 84,
            lineHeight: 28,
            runs: [
                {
                    text: '이야기에서 중심 소재가되는 낱말 외에도 이와 관련한 감각 언어(의성어, 의태어)와 감정표현 등 다양한 어휘를',
                    left: 30,
                    top: 0,
                },
                {
                    text: '      폭 넓게 다루기 때문에 더욱 생생한 표현에 노출됩니다. ',
                    left: 0,
                    top: 28,
                },
                {
                    text: '이러한 언어 자극은 한글을 깨치지 않은 아이에게 부모가',
                    color: '#FF4A00',
                    left: 453.69,
                    top: 28,
                },
                {
                    text: '      책을 읽어 줄 때 얻을 수 있는 다독의 효과와 동일한 효과를 기대할 수 있습니다.',
                    color: '#FF4A00',
                    left: 0,
                    top: 56,
                },
            ],
            bullet: true,
            font: 'Pretendard',
            size: 20,
            weight: 500,
            color: '#1D1D1D',
        },
        {
            key: '2019:588',
            tag: 'p',
            left: 176,
            top: 7247,
            width: 919,
            height: 56,
            lineHeight: 28,
            runs: [
                {
                    text: '애니메이션 외에도 다양한 유형으로 구성된 인터랙션 활동에서 지속적인 언어 자극이 이루어져 자연스럽게 표현력이',
                    left: 30,
                    top: 0,
                },
                {
                    text: '       향상되며, 이해 범주와 어휘가 확장되면서 보다 깊고 넓게 생각할 수 있는 사고력이 길러집니다.',
                    left: 0,
                    top: 28,
                },
            ],
            bullet: true,
            font: 'Pretendard',
            size: 20,
            weight: 500,
            color: '#1D1D1D',
        },
        {
            key: '2019:579',
            tag: 'h3',
            left: 542.5,
            top: 7438,
            width: 177,
            height: 28,
            lineHeight: 28,
            runs: [
                {
                    text: '한글 1단계 (한글 입문)',
                    left: 0.38,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 20,
            weight: 500,
            color: 'white',
        },
        {
            key: '2019:580',
            tag: 'p',
            left: 464,
            top: 7471,
            width: 334,
            height: 36,
            lineHeight: 36,
            runs: [
                {
                    text: '그림글자를 활용한 통문자 학습',
                    left: 0.31,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 28,
            weight: 800,
            color: 'white',
        },
        {
            key: '2019:574',
            tag: 'p',
            left: 187,
            top: 7854,
            width: 849,
            height: 56,
            lineHeight: 28,
            runs: [
                {
                    text: '윙크 한글 1단계는 유아가 자신의 주변에서 흔히 볼 수 있는 사물의 이름을 문자로 표현할 수 있음을 깨닫고,',
                    left: 30,
                    top: 0,
                },
                {
                    text: '그림과 함께 거부감 없이 문자를 받아들이는 훈련을 하는 과정입니다.',
                    color: '#FF4A00',
                    left: 29.297,
                    top: 28,
                },
            ],
            bullet: true,
            font: 'Pretendard',
            size: 20,
            weight: 500,
            color: '#1D1D1D',
        },
        {
            key: '2019:575',
            tag: 'p',
            left: 187,
            top: 7935,
            width: 708,
            height: 56,
            lineHeight: 28,
            runs: [
                {
                    text: '1단계에서는 통글자 학습의 일환으로서, 좀 더 흥미롭게 문자를 만날 수 있도록 하기 위해',
                    left: 30,
                    top: 0,
                },
                {
                    text: '      글자 속에 그림이 포함되어 있는 ‘느낌 글자\'로 첫 학습을 시작합니다.',
                    color: '#FF4A00',
                    left: 0,
                    top: 28,
                },
            ],
            bullet: true,
            font: 'Pretendard',
            size: 20,
            weight: 500,
            color: '#1D1D1D',
        },
        {
            key: '2019:577',
            tag: 'p',
            left: 187,
            top: 8016,
            width: 864,
            height: 28,
            lineHeight: 28,
            runs: [
                {
                    text: '이어서',
                    left: 30,
                    top: 0,
                },
                {
                    text: '그림과 함께 일반 글자(먹글자)를 한꺼번에 이미지로 각인하는 통글자 학습',
                    color: '#FF4A00',
                    left: 86.738,
                    top: 0,
                },
                {
                    text: '을 본격적으로 진행합니다.',
                    left: 658.69,
                    top: 0,
                },
            ],
            bullet: true,
            font: 'Pretendard',
            size: 20,
            weight: 500,
            color: '#1D1D1D',
        },
        {
            key: '2019:576',
            tag: 'p',
            left: 187,
            top: 8069,
            width: 894,
            height: 56,
            lineHeight: 28,
            runs: [
                {
                    text: '30주 동안의 학습을 통해 유아는 문자와 친숙해지고 아는 글자가 생길 뿐 아니라, 어느새 낱말을 이루는 글자들의',
                    left: 30,
                    top: 0,
                },
                {
                    text: '      소리에 집중하게 되어 음절 학습을 할 수 있는 준비가 됩니다.',
                    left: 0,
                    top: 28,
                },
            ],
            bullet: true,
            font: 'Pretendard',
            size: 20,
            weight: 500,
            color: '#1D1D1D',
        },
        {
            key: '2019:572',
            tag: 'h3',
            left: 541,
            top: 8260,
            width: 180,
            height: 28,
            lineHeight: 28,
            runs: [
                {
                    text: '한글 2단계 (한글 기본)',
                    left: 0.43,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 20,
            weight: 500,
            color: 'white',
        },
        {
            key: '2019:573',
            tag: 'p',
            left: 497,
            top: 8293,
            width: 268,
            height: 36,
            lineHeight: 36,
            runs: [
                {
                    text: '낱글자와 자음, 모음 학습',
                    left: 0.04,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 28,
            weight: 800,
            color: 'white',
        },
        {
            key: '2019:570',
            tag: 'h3',
            left: 511,
            top: 8366,
            width: 241,
            height: 34,
            lineHeight: 34,
            runs: [
                {
                    text: '초등 1학년 교과 수준 포함',
                    left: 0.1,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 24,
            weight: 700,
            color: '#4A4A4A',
        },
        {
            key: '2019:566',
            tag: 'p',
            left: 197,
            top: 8699,
            width: 876,
            height: 56,
            lineHeight: 28,
            runs: [
                {
                    text: '윙크 한글 2단꼐는 유아가 낱자와 글자들의 조합으로 한글이 이루어져 있다는 점을 알고, 각 낱글자와 글자들은',
                    left: 30,
                    top: 0,
                },
                {
                    text: '고유한 소리(음절)를 갖고 있다는 점을 깨닫게 됩니다.',
                    left: 29.297,
                    top: 28,
                },
            ],
            bullet: true,
            font: 'Pretendard',
            size: 20,
            weight: 500,
            color: '#1D1D1D',
        },
        {
            key: '2019:567',
            tag: 'p',
            left: 197,
            top: 8780,
            width: 837,
            height: 56,
            lineHeight: 28,
            runs: [
                {
                    text: '2단계에서는 우선 공통 음절이 있는 낱말들을 중심으로 낱말을 글자 단위로 인지하는 훈련을 반복한 후에 ',
                    left: 30,
                    top: 0,
                },
                {
                    text: '공통 음절이 없는 낱말들을 읽는 훈련을 진행합니다.',
                    left: 29.297,
                    top: 28,
                },
            ],
            bullet: true,
            font: 'Pretendard',
            size: 20,
            weight: 500,
            color: '#1D1D1D',
        },
        {
            key: '2019:569',
            tag: 'p',
            left: 197,
            top: 8861,
            width: 882,
            height: 56,
            lineHeight: 28,
            runs: [
                {
                    text: '이어서',
                    left: 30,
                    top: 0,
                },
                {
                    text: '각각의 글자를 이루는',
                    left: 86.738,
                    top: 0,
                },
                {
                    text: ' 자음과 모음의 이름과 소리, 조합 방법 ',
                    color: '#FF4A00',
                    left: 252.07,
                    top: 0,
                },
                {
                    text: '등을 익힘으로써 본격적으로 낱말의 구조를',
                    left: 550.66,
                    top: 0,
                },
                {
                    text: '      학습합니다.',
                    left: 0,
                    top: 28,
                },
            ],
            bullet: true,
            font: 'Pretendard',
            size: 20,
            weight: 500,
            color: '#1D1D1D',
        },
        {
            key: '2019:568',
            tag: 'p',
            left: 197,
            top: 8942,
            width: 756,
            height: 28,
            lineHeight: 28,
            runs: [
                {
                    text: '자음 모음 학습을 더 흥미롭고 수월하게 학습하도록 하기 위해 ',
                    left: 30,
                    top: 0,
                },
                {
                    text: '흉내 내는 말을 병행 학습',
                    color: '#FF4A00',
                    left: 506.07,
                    top: 0,
                },
                {
                    text: '합니다.',
                    left: 698.46,
                    top: 0,
                },
            ],
            bullet: true,
            font: 'Pretendard',
            size: 20,
            weight: 500,
            color: '#1D1D1D',
        },
        {
            key: '2019:540',
            tag: 'h3',
            left: 540,
            top: 9117.1333,
            width: 180,
            height: 28,
            lineHeight: 28,
            runs: [
                {
                    text: '한글 3단계 (한글 완성)',
                    left: 0.15,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 20,
            weight: 500,
            color: 'white',
        },
        {
            key: '2019:541',
            tag: 'p',
            left: 362.5,
            top: 9147.1333,
            width: 535,
            height: 36,
            lineHeight: 36,
            runs: [
                {
                    text: '받침있는 자음, 모음 조합 학습과 문장 읽기의 기초',
                    left: 0.02,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 28,
            weight: 800,
            color: 'white',
        },
        {
            key: '2019:534',
            tag: 'h3',
            left: 488,
            top: 9218.043,
            width: 271,
            height: 33.3861,
            lineHeight: 33.3861,
            runs: [
                {
                    text: '초등 1~2학년 교과 수준 포함',
                    left: 0.18,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 24,
            weight: 700,
            color: '#4A4A4A',
        },
        {
            key: '2019:535',
            tag: 'p',
            left: 178,
            top: 9556,
            width: 798,
            height: 28,
            lineHeight: 28,
            runs: [
                {
                    text: '윙크 한글 3단계에서는 ',
                    left: 30,
                    top: 0,
                },
                {
                    text: '받침 글자의 구조',
                    color: '#FF4A00',
                    left: 212.7,
                    top: 0,
                },
                {
                    text: '를 익히면서 받침이 있는 낱말들의 발음 특성을 체득합니다.',
                    left: 343.46,
                    top: 0,
                },
            ],
            bullet: true,
            font: 'Pretendard',
            size: 20,
            weight: 500,
            color: '#1D1D1D',
        },
        {
            key: '2019:536',
            tag: 'p',
            left: 178,
            top: 9609,
            width: 788,
            height: 28,
            lineHeight: 28,
            runs: [
                {
                    text: '그와 함께 ',
                    left: 30,
                    top: 0,
                },
                {
                    text: '문장 읽기 기초 학습을 위한 다양한 서술어 표현',
                    color: '#FF4A00',
                    left: 108.906,
                    top: 0,
                },
                {
                    text: '(상태를 나타내는 말) 학습을 병행합니다.',
                    left: 471.5,
                    top: 0,
                },
            ],
            bullet: true,
            font: 'Pretendard',
            size: 20,
            weight: 500,
            color: '#1D1D1D',
        },
        {
            key: '2019:537',
            tag: 'p',
            left: 178,
            top: 9662,
            width: 901,
            height: 84,
            lineHeight: 28,
            runs: [
                {
                    text: '이어서 2어절부터 4어절에 이르기까지의 다양한 문장 읽기를 반복하면서 우리말의 문장구조에 대한 특성을 ',
                    left: 30,
                    top: 0,
                },
                {
                    text: '      이해하고, 그와 함께 받침이 없는 낱말부터 있는 낱말, 여러가지 예외적 발음 규칙이 있는 어려운 낱말 쓰기 방법을 ',
                    left: 0,
                    top: 28,
                },
                {
                    text: '      병행하며 ',
                    left: 0,
                    top: 56,
                },
                {
                    text: '초등 받아쓰기에 대비할 수 있도록 맞춤법 쓰기를 집중 훈련합니다.',
                    color: '#FF4A00',
                    left: 103.32,
                    top: 56,
                },
            ],
            bullet: true,
            font: 'Pretendard',
            size: 20,
            weight: 500,
            color: '#1D1D1D',
        },
        {
            key: '2019:555',
            tag: 'h3',
            left: 519,
            top: 9901.2474,
            width: 220,
            height: 28,
            lineHeight: 28,
            runs: [
                {
                    text: '국어 4단계 (초등 국어 발전)',
                    left: 0.31,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 20,
            weight: 500,
            color: 'white',
        },
        {
            key: '2019:556',
            tag: 'p',
            left: 440.5,
            top: 9931.2474,
            width: 377,
            height: 36,
            lineHeight: 36,
            runs: [
                {
                    text: '문장 쓰기와 기초 문법 짧은 글 읽기',
                    left: 0.32,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 28,
            weight: 800,
            color: 'white',
        },
        {
            key: '2019:557',
            tag: 'h3',
            left: 491,
            top: 10003.1533,
            width: 276,
            height: 33.4365,
            lineHeight: 33.4365,
            runs: [
                {
                    text: '초등 2~3학년 교과 수준 포함',
                    left: 0.45,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 24,
            weight: 700,
            color: '#4A4A4A',
        },
        {
            key: '2019:550',
            tag: 'p',
            left: 190,
            top: 10349.043,
            width: 860,
            height: 56,
            lineHeight: 28,
            runs: [
                {
                    text: '윙크 국어 4단계부터는 여러 가지 문장 구성 성분으로 이루어진 다양한 형태의 문장을 직접 쓰고 완성해 보며',
                    left: 30,
                    top: 0,
                },
                {
                    text: '      본격적인 문장 집중 쓰기 훈련을 합니다.',
                    color: '#FF4A00',
                    left: 0,
                    top: 28,
                },
            ],
            bullet: true,
            font: 'Pretendard',
            size: 20,
            weight: 500,
            color: '#1D1D1D',
        },
        {
            key: '2019:551',
            tag: 'p',
            left: 190,
            top: 10430.043,
            width: 591,
            height: 28,
            lineHeight: 28,
            runs: [
                {
                    text: '그와 함께 국어의 완성을 위한 ',
                    left: 30,
                    top: 0,
                },
                {
                    text: '문법과 국어 지식, 어휘 학습을 병행합니다.',
                    color: '#FF4A00',
                    left: 261.84,
                    top: 0,
                },
            ],
            bullet: true,
            font: 'Pretendard',
            size: 20,
            weight: 500,
            color: '#1D1D1D',
        },
        {
            key: '2019:552',
            tag: 'p',
            left: 190,
            top: 10483.043,
            width: 865,
            height: 56,
            lineHeight: 28,
            runs: [
                {
                    text: '유아들이 재미있게 읽을 수 있는 동시(노랫말)을 시작으로 전래 동화, 일기, 기행문, 위인전, 설명문, 논설문 등',
                    left: 30,
                    top: 0,
                },
                {
                    text: '      60여 편에 이르는 여러 가지 장르 글 읽기와 독해 활동으로 국어의 읽기 영역에 대한 역량을 기릅니다.',
                    color: '#FF4A00',
                    left: 0,
                    top: 28,
                },
            ],
            bullet: true,
            font: 'Pretendard',
            size: 20,
            weight: 500,
            color: '#1D1D1D',
        },
        {
            key: '2019:548',
            tag: 'h3',
            left: 515.5,
            top: 10684.0435,
            width: 219,
            height: 28,
            lineHeight: 28,
            runs: [
                {
                    text: '국어 5단계 (초등 국어 강화)',
                    left: 0.1,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 20,
            weight: 500,
            color: 'white',
        },
        {
            key: '2019:549',
            tag: 'p',
            left: 412.5,
            top: 10714.0435,
            width: 425,
            height: 36,
            lineHeight: 36,
            runs: [
                {
                    text: '심화 문법과 국어지식 긴 글 독해력 학습',
                    left: 0.12,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 28,
            weight: 800,
            color: 'white',
        },
        {
            key: '2019:542',
            tag: 'h3',
            left: 487,
            top: 10786.229,
            width: 277,
            height: 33.4589,
            lineHeight: 33.4589,
            runs: [
                {
                    text: '초등 3~4학년 교과 수준 포함',
                    left: 0.34,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 24,
            weight: 700,
            color: '#4A4A4A',
        },
        {
            key: '2019:543',
            tag: 'p',
            left: 171,
            top: 11133.0435,
            width: 931,
            height: 28,
            lineHeight: 28,
            runs: [
                {
                    text: '윙크 국어 5단계에서는 문법적 개념까지 적용하여 좀 더 긴 문장을 쓰고, 변형하는 등의 ',
                    left: 30,
                    top: 0,
                },
                {
                    text: '심화 문장 쓰기 학습을 합니다.',
                    color: '#FF4A00',
                    left: 698.44,
                    top: 0,
                },
            ],
            bullet: true,
            font: 'Pretendard',
            size: 20,
            weight: 500,
            color: '#1D1D1D',
        },
        {
            key: '2019:544',
            tag: 'p',
            left: 171,
            top: 11186.0435,
            width: 896,
            height: 84,
            lineHeight: 28,
            runs: [
                {
                    text: '글을 쓰는 데에 있어서 기본적으로 쌓아 두어야 하는 국어적 지식을 병행하여 학습하게 되며, 여러 가지 글의 ',
                    left: 30,
                    top: 0,
                },
                {
                    text: '      종류를 읽으며 내용을 파악하고 배경지식을 쌓을 수 있는 읽기 학습, 글을 읽으며 자신의 생각과 의견을 정리하고, ',
                    left: 0,
                    top: 28,
                },
                {
                    text: '      숨겨진 의미를 찾아보는 등의 ',
                    left: 0,
                    top: 56,
                },
                {
                    text: '심도 있는 독해력을 요하는 ‘꼼꼼하게 읽기 학습\'',
                    color: '#FF4A00',
                    left: 256.25,
                    top: 56,
                },
                {
                    text: '도 진행합니다.',
                    left: 622.7,
                    top: 56,
                },
            ],
            bullet: true,
            font: 'Pretendard',
            size: 20,
            weight: 500,
            color: '#1D1D1D',
        },
        {
            key: '2019:545',
            tag: 'p',
            left: 171,
            top: 11295.0435,
            width: 919,
            height: 56,
            lineHeight: 28,
            runs: [
                {
                    text: '윙크 국어 5단계 학습을 통해 아이는 초등 4~5학년 수준의 문장력 및 문법적 지식을 습득하게 되며, 60여 편 이상의',
                    left: 30,
                    top: 0,
                },
                {
                    text: '      글을 접하면서 독해력 향상 훈련을 합니다.',
                    left: 0,
                    top: 28,
                },
            ],
            bullet: true,
            font: 'Pretendard',
            size: 20,
            weight: 500,
            color: '#1D1D1D',
        },
        {
            key: '2019:560',
            tag: 'p',
            left: 398,
            top: 11539,
            width: 436,
            height: 45,
            lineHeight: 45,
            runs: [
                {
                    text: '윙크 수준별 수학∙연산 ',
                    left: 0,
                    top: 0,
                },
                {
                    text: '보러가기',
                    color: '#59E7E1',
                    left: 312.74,
                    top: 0,
                },
            ],
            font: 'Paperlogy',
            size: 35,
            weight: 800,
            color: 'white',
        },
    ],
    label: '한글·국어',
    frame: '2019:529',
    heading: '2019:717',
    link: {
        key: '2019:560',
        left: 336,
        top: 11514,
        width: 589,
        height: 95,
        href: '/subject/math',
        id: 'subject-kor-math-button',
    },
    animations: [],
};
